<template>
    <div class="card-inner">
        <h4 class="title" v-if="hasTitle">
            <div class="image" v-if="hasImage"><img :src="imageUrl"></div>
            <span class="text">{{ title }}</span>
        </h4>
        <div class="description" v-if="hasBody">
            <div class="image" v-if="!hasBody && hasImage"><img :src="imageUrl"></div>
            <p class="text">{{ body }}</p>
        </div>
        <a :href="url" class="url" v-if="hasUrl">Open Application</a>
    </div>
</template>

<script>
export default {
    name: "qw-card",
    props: {
        title: {
            required: false,
            type: String,
            default: null
        },
        body: {
            required: false,
            type: String,
            default: null
        },
        image: {
            required: false,
            type: String,
            default: null
        },
        url: {
            required: false,
            type: String,
            default: null
        }
    },
    computed: {
        hasTitle() {
            return !!(this.title && this.title.length);
        },
        hasBody() {
            return !!(this.body && this.body.length);
        },
        hasImage() {
            return !!(this.image && this.image.length);
        },
        hasUrl() {
            return !!(this.url && this.url.length);
        },
        imageUrl() {
            return `${process.env.VUE_APP_CHATBOT_URL}/${this.image}`;
        },
        date() {
            return +new Date;
        }
    }
}
</script>

<style lang="scss" scoped>
.card-inner {
    width: 100%;
    background-color: $white;
    padding: 10px;
    border-radius: 10px;
    .title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0px 0px 10px 0px;
        .text {
            font-size: 14px;
            font-weight: 700;
            font-family: $lato;
            margin: 0;
        }
    }
    .description {
        font-size: 13px;
        font-family: $lato;
        margin: 0px 0px 10px 0px;
        color: $dark-gray;
        .text {
            margin: 0;
        }
    }
    .url {
        display: block;
        width: 100%;
        padding: 3px 7px;
        color: $white!important;
        background-color: $primary;
        border: 1px solid transparent;
        border-radius: 20px;
        font-size: 13px;
        text-align: center;
        cursor: pointer;
        @include fastestTransition;
        &:hover {
            border: 1px solid $primary;
            color: $primary!important;
            background-color: $white;
            text-decoration: none;
        }
    }
    .image {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        margin: 0px 10px 0px 0px;
        border-radius: 50%;
        overflow: hidden;
        img {
            width: 300%;
            max-height: 100%;
        }
    }
    .url {
        margin: 0;
    }
}
.dark {
    .card-inner {
        background-color: $extra-dark-gray;
        .title {
            .text {
                color: $lighter-gray;
            }
        }
        .description {
            color: $gray;
        }
        .url {
            color: $white!important;
            background-color: $primary;
            border: 1px solid transparent;
            &:hover {
                border: 1px solid transparent;
                color: $white!important;
                background-color: darken($primary, 5%);
            }
        }
    }
}
</style>
